<template>
  <avs-card>
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar bgTable"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />
        <slot
          name="actions"
          v-bind:dataset="dataset"
        />
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10 bgTable"
        disable-pagination
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        hide-default-footer
        :items="dataset"
        :loading="loading"
        loading-text="Loading "
        no-results-text="Not found"
        :search="search"
        @dblclick:row="($event, { item }) => toEdit(item)"
      >

        <template v-slot:item.is_active="{ item }">
          <avs-chip
            class="min-width-120"
            color="success"
            iconColor="blue"
            text-color="black"
            v-if="item.is_active"
          >
            Active
          </avs-chip>
          <template v-else>
            <avs-chip
              class="min-width-120"
              color="danger"
              iconColor="black"
              text-color="black"
              v-if="item.is_active"
            >
              Inactive
            </avs-chip>
          </template>
        </template>
        <template v-slot:item.logo="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.logo"
          >
            Oui
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.template="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.template"
          >
            Oui
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.captionImage="{ item }">
          <avs-chip
            class="min-width-120"
            color="info"
            iconColor="blue"
            text-color="blue"
            v-if="item.captionImage"
          >
            Oui
          </avs-chip>
          <template v-else>
            {{ $t("/") }}
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              :to="getToEditLink(item)"
              :spantext="
                $t('actions.edit', { entity: $tc('categories.pcqdsi.name', 1).toLowerCase() })
              "
            />
            <avs-deleteButton
              @click="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', { entity: $tc('categories.pcqdsi.name', 1).toLowerCase() })
              "
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="PartnerCard"
      />
    </template>
  </avs-card>
</template>

<script>
import { PartnerCardService } from "@/services"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "PartnerCardsTable",
  data() {
    return {
      dataset: [],
      deleteDialogIsOpen: false,
      document: null,
      headers: [
        { text: "Nom", value: "name", class: "min-width-200", sortable: true },
        { text: "Description.", value: "description", class: "min-width-150", sortable: false },
        { text: "Status", value: "is_active", sortable: false },
        { text: "Logo", value: "logo", class: "min-width-150", sortable: false },
        { text: "Template", value: "template", sortable: false },
        { text: "Image Constextuelle", value: "captionImage", sortable: false },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
          align: "right",
          width: 200
        }
      ],
      loading: false,
      search: "",
      selectedItem: null,
      template: null,
      values: null
    }
  },
  methods: {
    toDatetime,
    getDataset() {
      this.loading = true
      PartnerCardService.get()
        .then(response => {
          this.dataset = response.results
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getToEditLink(item) {
      return {
        name: "PartnerCardCreateUpdate",
        params: { id: item.id }
      }
    },
    getTaskName(item) {
      return item.task.name ? item.task.name : item.name.toUpperCase()
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete(item) {
      PartnerCardService.remove(this, this.selectedItem.id)
        .then(r => {
          this.dataset = this.dataset.filter(nc => nc.id !== this.selectedItem.id)
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.deleted", {
              entity: this.$tc("categories.pcqdsi.name", 1)
            }),
            color: "success"
          })
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.deleteDialogIsOpen = false
    },
    handleStatusComponent(task) {
      return task.status
    },
    isMettingDisabled(item) {
      return item.status === "Closed"
    },
    toEdit(item) {
      this.$router.push(this.getToEditLink(item))
    }
  },
  mounted() {
    this.getDataset()
  }
}
</script>

<style scoped>
.custom-toolbar >>> .v-toolbar__content {
  gap: 1rem;
}
</style>
